import React from "react";

export const Construction = () => (
  <svg
    width="160"
    height="144"
    viewBox="0 0 160 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="16"
        y="16"
        width="128"
        height="128"
      >
        <path
          d="M79.6025 143.851C114.729 143.851 143.205 115.375 143.205 80.2487C143.205 45.122 114.729 16.6462 79.6025 16.6462C44.4758 16.6462 16 45.122 16 80.2487C16 115.375 44.4758 143.851 79.6025 143.851Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path d="M143.205 16.6462H16V143.851H143.205V16.6462Z" fill="#F8F8F8" />
      </g>
      <mask
        id="mask1"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="16"
        y="16"
        width="128"
        height="128"
      >
        <path
          d="M80.1006 143.851C115.227 143.851 143.703 115.375 143.703 80.2487C143.703 45.122 115.227 16.6462 80.1006 16.6462C44.9739 16.6462 16.498 45.122 16.498 80.2487C16.498 115.375 44.9739 143.851 80.1006 143.851Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1)">
        <path d="M144.498 18H16.498V146H144.498V18Z" fill="#F8F8F8" />
        <path
          d="M88.6934 87.1303L88.759 91.9929L90.3291 93.5094L93.398 93.4011L94.9145 91.8309L94.8658 87.0229C95.5296 87.337 96.1547 87.7643 96.7122 88.3029C100.133 91.6053 99.2872 97.2898 95.0834 99.4672L95.2444 108.738H95.2524H95.2603L95.314 111.825H95.305H95.2981L95.4601 121.064C99.7294 123.091 100.788 128.737 97.4785 132.164C96.9398 132.722 96.3306 133.171 95.6777 133.508L95.6121 128.645L94.0419 127.129L90.9175 127.184L89.4019 128.754L89.5053 133.616C88.8414 133.302 88.2173 132.874 87.6588 132.336C84.2322 129.027 85.0919 123.345 89.2886 121.172C89.2111 116.696 88.9895 104.03 88.912 99.5745C88.2471 99.2595 87.6221 98.8331 87.0635 98.2935C84.3048 95.6292 84.2283 91.2336 86.8926 88.4749C87.4312 87.9164 88.0414 87.4682 88.6934 87.1303Z"
          fill="#9E999E"
        />
      </g>
      <mask
        id="mask2"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2)">
        <path d="M24.3037 84.99H130.232V80.02H24.3037V84.99Z" fill="#373B3C" />
      </g>
      <mask
        id="mask3"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3)">
        <path
          d="M126.229 106.006H130.209V73.4351H126.229V106.006Z"
          fill="#F94615"
        />
      </g>
      <mask
        id="mask4"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask4)">
        <path
          d="M24.3145 105.533H28.2932V74.8501H24.3145V105.533Z"
          fill="#FA4616"
        />
      </g>
      <mask
        id="mask5"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask5)">
        <path
          d="M62.2678 83.2543C61.3396 84.2849 59.9085 84.1746 58.5421 83.7025C58.5421 83.7025 57.6029 84.2899 55.9105 86.1701C51.7734 90.7634 49.8027 97.2628 51.1145 106.132L53.2193 106.036C53.2193 106.036 52.9401 101.007 55.5408 97.861C57.1289 95.9401 59.9274 95.1748 62.0929 97.1256C62.7677 97.7329 62.9217 97.871 63.4037 98.3053C63.4037 98.3053 65.9408 95.7701 67.7018 93.8143C66.9436 93.1316 66.9754 93.1604 65.759 92.0653C64.5426 90.9701 64.5217 88.3217 65.6506 87.0675C66.7518 85.8442 67.7306 85.8114 68.6698 85.8819L68.8785 83.1768L63.0479 80.8206C63.0479 80.8206 63.4882 81.8988 62.2678 83.2543Z"
          fill="#C7C9C9"
        />
      </g>
      <mask
        id="mask6"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask6)">
        <path
          d="M67.3502 93.4976L63.1914 98.1151L78.6289 112.014L82.7864 107.398L67.3502 93.4976Z"
          fill="#8B8D93"
        />
      </g>
      <mask
        id="mask7"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask7)">
        <path
          d="M78.6289 112.014C79.0741 114.079 79.5849 114.667 80.4336 115.431C81.2813 116.195 103.652 136.455 105.63 138.237C105.63 138.237 106.174 139.055 106.755 138.41C107.336 137.764 109.308 135.575 109.308 135.575C109.308 135.575 111.217 133.454 111.798 132.809C112.38 132.162 111.508 131.708 111.508 131.708C109.53 129.926 87.1596 109.667 86.3119 108.902C85.4632 108.139 84.8252 107.691 82.7253 107.465L78.6289 112.014Z"
          fill="#FFC62C"
        />
      </g>
      <mask
        id="mask8"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask8)">
        <path
          d="M66.3631 78.448C66.3631 78.448 65.6317 77.9511 64.9172 78.7451L63.0488 80.8201L65.3117 82.8584L66.4058 83.8442L68.6697 85.8815L70.539 83.8065C71.2536 83.0124 70.6831 82.3377 70.6831 82.3377L69.0702 80.8857L67.976 79.8999L66.3631 78.448Z"
          fill="#C7C9C9"
        />
      </g>
      <mask
        id="mask9"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask9)">
        <path
          d="M66.3622 78.448C66.3622 78.448 65.6308 77.9511 64.9162 78.7451L64.2285 79.5093L66.4914 81.5476L67.5855 82.5324L69.8494 84.5707L70.5381 83.8065C71.2526 83.0124 70.6822 82.3377 70.6822 82.3377L69.0693 80.8857L67.9751 79.8999L66.3622 78.448Z"
          fill="#6E6E6E"
        />
      </g>
      <mask
        id="mask10"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask10)">
        <path
          d="M92.6361 117.922C93.2562 118.225 94.3951 117.747 95.3024 115.886L95.5728 116.018L95.8441 116.151C94.9357 118.011 95.2607 119.202 95.8808 119.505L93.1608 123.515L91.1504 122.535L92.6361 117.922Z"
          fill="#949499"
        />
      </g>
      <mask
        id="mask11"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask11)">
        <path
          d="M130.214 104.566H110.668H43.8431H24.2969V140.442H43.8431H110.668H130.214V104.566Z"
          fill="#FA4616"
        />
      </g>
      <mask
        id="mask12"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask12)">
        <path
          d="M113.07 90.7044L88.0352 75.6624L88.3432 75.1486C89.0369 73.9928 89.5517 73.4284 91.5552 73.5834C93.5576 73.7394 95.2342 73.972 95.2342 73.972L100.011 66.0217C103.868 59.6018 111.776 54.4699 122.153 56.685C122.153 56.685 126.777 55.0959 132.427 58.4897C138.074 61.8845 138.843 66.7133 138.843 66.7133C145.67 74.8346 144.85 84.2259 140.993 90.6448L136.215 98.5951C136.215 98.5951 137.208 99.9675 138.286 101.664C139.363 103.358 139.107 104.079 138.413 105.235L138.104 105.746L113.07 90.7044Z"
          fill="#FFC62C"
        />
      </g>
      <mask
        id="mask13"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask13)">
        <path
          d="M92.9141 78.5935C100.466 78.2377 108.735 80.7619 116.31 85.3135C123.885 89.864 129.995 95.9808 133.226 102.816L92.9141 78.5935Z"
          fill="#FFD059"
        />
      </g>
      <mask
        id="mask14"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask14)">
        <path
          d="M135.222 60.6095C138.347 63.5958 138.843 66.7133 138.843 66.7133L139.062 66.9787C137.443 67.8045 134.63 69.7454 131.342 72.9632C130.56 72.3511 129.752 71.7578 128.923 71.1834C130.642 68.2249 133.051 64.1851 135.222 60.6095ZM121.815 56.6144L122.153 56.685C122.153 56.685 125.076 55.6803 129.111 56.9732C126.943 60.5439 124.542 64.5707 122.827 67.5232C121.942 67.0681 121.051 66.6388 120.154 66.2413C121.452 61.8269 121.845 58.4321 121.815 56.6144Z"
          fill="#FFD059"
        />
      </g>
      <mask
        id="mask15"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask15)">
        <path
          d="M116.1 74.0977C115.037 75.8666 114.955 77.9506 115.694 79.7195C116.971 79.6003 118.296 79.8716 119.479 80.5831C120.663 81.2937 121.523 82.3362 122.018 83.5198C123.927 83.3429 125.729 82.2914 126.792 80.5225C128.566 77.569 127.611 73.7379 124.658 71.964C121.706 70.1901 117.874 71.1441 116.1 74.0977ZM118.718 75.6708C119.623 74.1623 121.579 73.6743 123.086 74.5806C124.593 75.486 125.08 77.4418 124.175 78.9493C123.27 80.4569 121.314 80.9449 119.806 80.0395C118.299 79.1332 117.812 77.1774 118.718 75.6708Z"
          fill="#EE3E42"
        />
      </g>
      <mask
        id="mask16"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask16)">
        <path
          d="M21.4648 109.286H132.396V104.566H21.4648V109.286Z"
          fill="#C92B00"
        />
      </g>
      <mask
        id="mask17"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask17)">
        <path
          d="M45.1843 104.376L45.3731 104.379H49.5858C48.8494 103.921 47.2981 103.191 45.1843 103.191C37.8064 103.191 37.8541 108.045 39.2444 111.82C40.5473 115.361 43.0576 118.907 43.0576 122.631H44.75C44.75 118.777 42.2287 115.181 40.8822 111.525C39.7989 108.582 39.1609 104.376 45.1843 104.376Z"
          fill="white"
        />
      </g>
      <mask
        id="mask18"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask18)">
        <path
          d="M41.2686 132.066C41.2686 131.845 41.5031 131.667 41.7933 131.667H41.9354C42.2256 131.667 42.4601 131.845 42.4601 132.066V134.467C42.4601 134.688 42.2256 134.867 41.9354 134.867H41.7933C41.5031 134.867 41.2686 134.688 41.2686 134.467V132.066Z"
          fill="white"
        />
      </g>
      <mask
        id="mask19"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask19)">
        <path
          d="M45.3652 132.066C45.3652 131.845 45.5998 131.667 45.889 131.667H46.0321C46.3223 131.667 46.5568 131.845 46.5568 132.066V134.467C46.5568 134.688 46.3223 134.867 46.0321 134.867H45.889C45.5998 134.867 45.3652 134.688 45.3652 134.467V132.066Z"
          fill="white"
        />
      </g>
      <mask
        id="mask20"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask20)">
        <path
          d="M44.1208 132.913H48.3882V130.337C48.3882 129.196 47.7531 128.731 46.9959 128.181C46.2366 127.633 45.5578 127.043 45.5578 125.014V122.65C45.5578 121.803 45.3044 121.846 45.051 121.846H43.8674H42.6838C42.4304 121.846 42.177 121.803 42.177 122.65V125.014C42.177 127.043 41.4982 127.633 40.74 128.181C39.9807 128.731 39.3477 129.196 39.3477 130.337V132.913H43.614H44.1208Z"
          fill="white"
        />
      </g>
      <mask
        id="mask21"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask21)">
        <path
          d="M88.2637 141.103V138.356H120.767C121.483 138.356 123.854 138.271 124.392 137.515L130.279 138.356V139.73V141.103L124.392 141.946C123.854 141.188 121.483 141.103 120.766 141.103H88.2637Z"
          fill="#C7C9C9"
        />
      </g>
      <mask
        id="mask22"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask22)">
        <path
          d="M67.4923 144.21C65.4978 144.21 63.8809 142.593 63.8809 140.599V138.862C63.8809 136.867 65.4978 135.249 67.4923 135.249H88.7584C90.7529 135.249 92.3698 136.866 92.3698 138.862V140.599C92.3698 141.709 91.8689 142.702 91.0809 143.365C90.4528 143.892 89.6428 144.21 88.7584 144.21H67.4923Z"
          fill="#7FDCEB"
        />
      </g>
      <mask
        id="mask23"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask23)">
        <path
          d="M91.0801 143.365C91.4508 142.994 91.9069 142.538 92.7337 142.538C93.5596 142.538 94.0157 142.994 94.3864 143.365H97.1969V141.446V136.096H94.3864C94.0157 136.466 93.5596 136.922 92.7327 136.922C91.9069 136.922 91.4508 136.466 91.0801 136.096V143.365Z"
          fill="#7FDCEB"
        />
      </g>
      <mask
        id="mask24"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask24)">
        <path
          d="M67.7307 143.377C67.203 143.377 66.9844 142.948 66.9844 142.421V142.456C66.9844 141.929 67.203 141.501 67.7307 141.501H88.5973C89.125 141.501 89.3446 141.929 89.3446 142.456V142.42C89.3446 142.948 89.125 143.377 88.5983 143.377H67.7307Z"
          fill="#009BB4"
        />
      </g>
      <mask
        id="mask25"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask25)">
        <path
          d="M67.7297 140.668C67.202 140.668 66.9834 140.239 66.9834 139.712V139.748C66.9834 139.22 67.202 138.793 67.7297 138.793L88.5973 138.792C89.124 138.792 89.3436 139.22 89.3436 139.748V139.712C89.3436 140.239 89.124 140.668 88.5973 140.668H67.7297Z"
          fill="#009BB4"
        />
      </g>
      <mask
        id="mask26"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask26)">
        <path
          d="M67.7307 137.959C67.203 137.959 66.9844 137.531 66.9844 137.003V137.039C66.9844 136.511 67.203 136.083 67.7307 136.083H88.5983C89.125 136.083 89.3446 136.511 89.3446 137.039V137.003C89.3446 137.531 89.125 137.959 88.5983 137.959H67.7307Z"
          fill="#009BB4"
        />
      </g>
      <mask
        id="mask27"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask27)">
        <path
          d="M91.0801 143.365C91.4508 142.994 91.9069 142.538 92.7337 142.538C93.5596 142.538 94.0157 142.994 94.3864 143.365V136.096C94.0157 136.466 93.5596 136.922 92.7327 136.922C91.9069 136.922 91.4508 136.466 91.0801 136.096V143.365Z"
          fill="#009BB4"
        />
      </g>
      <mask
        id="mask28"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="21"
        y="42"
        width="123"
        height="103"
      >
        <path
          d="M21.4648 144.822H143.94V42.7324H21.4648V144.822Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask28)">
        <path
          d="M124.391 141.945C124.391 141.098 123.251 140.1 120.71 140.1V139.73V139.359C123.251 139.359 124.391 138.361 124.391 137.515L130.279 138.356V141.103L124.391 141.945Z"
          fill="#8B8D93"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="160" height="144" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
